/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFlightCreditRequest
 */
export interface UpdateFlightCreditRequest {
    /**
     * IATA airline code (e.g. UA, DL, AA)
     * @type {string}
     * @memberof UpdateFlightCreditRequest
     */
    airline?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFlightCreditRequest
     */
    creditType?: UpdateFlightCreditRequestCreditTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateFlightCreditRequest
     */
    creditNumber?: string | null;
    /**
     * Updated credit face value (cannot change on partially-redeemed credits)
     * @type {number}
     * @memberof UpdateFlightCreditRequest
     */
    amount?: number;
    /**
     * ISO 4217 currency code
     * @type {string}
     * @memberof UpdateFlightCreditRequest
     */
    currency?: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateFlightCreditRequest
     */
    expirationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFlightCreditRequest
     */
    originalConfirmationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFlightCreditRequest
     */
    notes?: string | null;
}


/**
 * @export
 */
export const UpdateFlightCreditRequestCreditTypeEnum = {
    FlightCredit: 'flight_credit',
    Ecredit: 'ecredit',
    TripCredit: 'trip_credit',
    TravelFund: 'travel_fund',
    WalletCredit: 'wallet_credit',
    TravelBankCredit: 'travel_bank_credit',
    ElectronicTravelCertificate: 'electronic_travel_certificate',
    Voucher: 'voucher',
    Refund: 'refund'
} as const;
export type UpdateFlightCreditRequestCreditTypeEnum = typeof UpdateFlightCreditRequestCreditTypeEnum[keyof typeof UpdateFlightCreditRequestCreditTypeEnum];


/**
 * Check if a given object implements the UpdateFlightCreditRequest interface.
 */
export function instanceOfUpdateFlightCreditRequest(value: object): value is UpdateFlightCreditRequest {
    return true;
}

export function UpdateFlightCreditRequestFromJSON(json: any): UpdateFlightCreditRequest {
    return UpdateFlightCreditRequestFromJSONTyped(json, false);
}

export function UpdateFlightCreditRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFlightCreditRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'airline': json['airline'] == null ? undefined : json['airline'],
        'creditType': json['credit_type'] == null ? undefined : json['credit_type'],
        'creditNumber': json['credit_number'] == null ? undefined : json['credit_number'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'expirationDate': json['expiration_date'] == null ? undefined : (new Date(json['expiration_date'])),
        'originalConfirmationNumber': json['original_confirmation_number'] == null ? undefined : json['original_confirmation_number'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdateFlightCreditRequestToJSON(json: any): UpdateFlightCreditRequest {
    return UpdateFlightCreditRequestToJSONTyped(json, false);
}

export function UpdateFlightCreditRequestToJSONTyped(value?: UpdateFlightCreditRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'airline': value['airline'],
        'credit_type': value['creditType'],
        'credit_number': value['creditNumber'],
        'amount': value['amount'],
        'currency': value['currency'],
        'expiration_date': value['expirationDate'] == null ? value['expirationDate'] : value['expirationDate'].toISOString().substring(0,10),
        'original_confirmation_number': value['originalConfirmationNumber'],
        'notes': value['notes'],
    };
}

